import React from 'react';

import { TextWithDictionarySelector } from '../../../app/components/TextWithDictionarySelector';

const DICTIONARY_TYPE = 'Przyczyny wyprowadzenia poza system';

interface WithdrawalCommentSelectorProps {
  value?: string;
  onChange: (value: string) => void;
}

export const WithdrawalCommentSelector: React.FC<
  WithdrawalCommentSelectorProps
> = ({ value, onChange }) => (
  <TextWithDictionarySelector
    value={value}
    onChange={onChange}
    dictionaryType={DICTIONARY_TYPE}
    rows={2}
    emptyLabel="Brak przyczyn w słowniku"
  />
);
